const styles = {
  mapContainer: {
    position: "relative",
    "& .leaflet-container": {
      height: "100vh",
      width: "100vw",
    },
    "& .leaflet-div-icon": {
      background: "inherit",
      border: "none",
    },
    "& .leaflet-top.leaflet-right": {
      display: "none",
    },
    "& .leaflet-pane.leaflet-shadow-pane": {
      display: "none",
    },
    "& .leaflet-marker-pane img": {
      display: "none",
    },
    "& .leaflet-marker-pane img.custom-icon": {
      display: "block",
      border: "none !important",
      background: "none !important",
    },
  },
};

export default styles;
